import React from 'react';
import { useSelector } from 'react-redux';

import * as globalSelectors from '../../../selectors';
import { CONFIGURATION_TEST_TYPES } from '../../../constants';
import selectors from '../selectors';
import { useIsWebRtcSupported } from '../hooks/useIsWebRtcSupported';
import HomeButton from './ButtonHome';
import ButtonDeveloperOptions from './ButtonDeveloperOptions';
import ButtonTakeScreenshot from './ButtonTakeScreenshot';
import ButtonRotateDevice from './ButtonRotateDevice';
import ButtonRestartApp from './ButtonRestartApp';
import ButtonDeviceSettings from './ButtonDeviceSettings';
import ButtonTools from './ButtonTools';
import ButtonApplication from './ButtonApplication';

const RealDeviceSessionToolbar: React.FC = () => {
  const { isViewOnly } = useSelector(globalSelectors.mobileSessionSelector);
  const { device, testType } = useSelector(selectors.toolbarButtonSelector);
  const isWebRtcEnabled = useIsWebRtcSupported();
  const {
    changeLocaleSupported,
    isMuteSupported,
    takeScreenshotEnabled,
    toggleSystemAnimationsSupported,
    toggleWifiSupported,
  } = useSelector(globalSelectors.mobileSessionSelector);

  const showSettingButton = changeLocaleSupported ||
    toggleWifiSupported ||
    toggleSystemAnimationsSupported ||
    isWebRtcEnabled ||
    isMuteSupported;

  // Don't render the toolbar if the device is not available yet
  // because we can't determine which features are available
  if (!device) {
    return null;
  }

  return (
    <div
      className="mt-2 ml-2 overflow-y-auto"
      data-qa="live-session-toolbar"
    >
      <div
        className="bg-white rounded filter drop-shadow-md"
        role="menu"
      >
        {isViewOnly && (
          <ButtonDeveloperOptions role="menuitem" />
        )}

        {!isViewOnly && (
          <>
            <HomeButton role="menuitem" />

            <ButtonDeveloperOptions role="menuitem" />

            {takeScreenshotEnabled && (
              <ButtonTakeScreenshot role="menuitem" />
            )}

            <ButtonRotateDevice role="menuitem" />

            <ButtonRestartApp role="menuitem" />

            {showSettingButton && (
              <ButtonDeviceSettings role="menuitem" />
            )}

            <ButtonTools role="menuitem" />

            {testType === CONFIGURATION_TEST_TYPES.APP && (
              <ButtonApplication role="menuitem" />
            )}
          </>
        )}
      </div>
    </div>
  );
};

RealDeviceSessionToolbar.displayName = 'RealDeviceSessionToolbar';

export default RealDeviceSessionToolbar;
